import { useQuery, UseQueryOptions } from 'react-query';
import { getFundingSource } from '~/api/routes/auth/user';

import { useAccountQuery } from './useAccountQuery';

type UseFundingSourceQuery<TError, TData> = Omit<UseQueryOptions<string, TError, TData>, 'enabled'>;

export function useFundingSourceQuery<TError = unknown, TData = string>(options?: UseFundingSourceQuery<TError, TData> = {}) {
  const [accountId] = useAccountQuery();

  return useQuery(
    ['funding-source', accountId],
    () => getFundingSource(accountId as string),
    {
      enabled: !!accountId,
      ...options,
    },
  );
}
